	<div id="folder-list" class="mb-2">
		<div class="row justify-content-beetwen g-2">
			<div class="col">
				<h3 class="mb-0">{{ editMode ? 'Edit' : 'Create'}} Template</h3>
			</div>
			<div class="col-auto">
				<div class="d-flex gap-2 align-items-start">
					<a routerLink="/templates" class="btn btn-danger w-sm create-folder-modal flex-shrink-0">Cancel</a>
				</div>
			</div>
		</div>
	</div>

	<div class="card h-100" style="box-shadow: none">
		<div class="card-header border-0">
			<div class="progress progress-step-arrow progress-info">
				<div class="progress-bar w-100" *ngFor="let step of steps; let i = index" [ngClass]="i === currentStep+1 ? 'next' : i > currentStep+1 ? 'bg-light text-body after' : ''">{{ step }}</div>
			</div>
		</div>
		<div [ngSwitch]="currentStep" class="card-body h-100 pt-0 border-0">
			<ngx-simplebar class="px-3 file-manager-content-scroll">
				<div *ngSwitchCase="0">
					<form>
						<div class="mb-3">
							<div class="row">
								<div class="col-lg-6 col-12">
									<label for="name" class="form-label">Template name <span class="text-danger">*</span></label>
									<input type="text" class="form-control" id="name" placeholder="Enter template name" required [(ngModel)]="template_name" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !template_name }">
									<div class="invalid-feedback"> Please enter template name </div>
								</div>
							</div>
						</div>
						<div class="mb-3">
							<label for="description" class="form-label">Description</label>
							<quill-editor id="description" [styles]="{ height: '250px' }" [(ngModel)]="description" [ngModelOptions]="{standalone: true}" class="d-block"></quill-editor>
						</div>
					</form>	
				</div>
				<div *ngSwitchCase="1">
					<app-questionnaire-chapters></app-questionnaire-chapters>
				</div>
				<div *ngSwitchCase="2">
					
				</div>
			</ngx-simplebar>
			<div class="row mt-2">
				<div *ngIf="currentStep > 0" class="me-auto col">
					<button (click)="backStep()" class="btn btn-primary btn-load">Back</button>
				</div>
				<div class="text-end col">
					<button (click)="currentStep < steps.length-1 ? nextStep() : ''" class="btn btn-primary btn-load">
						<span class="d-flex justify-question-center">
							<span class="spinner-border" role="status" *ngIf="submitted && spinner">
								<span class="visually-hidden">Loading...</span>
							</span>
							<span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ currentStep < steps.length-1 ? 'Next' :  editMode ? 'update' : 'Create' }} </span>
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>

